import WCDatePicker from '@/components_v2/WCDatePicker';
import { parseDateToDay } from '@/utils/Date/parseDayDate';
import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  Text,
} from '@chakra-ui/react';
import React, { useCallback, useState } from 'react';

import { QuestionTitle } from '../common';
import { DatePickerProps } from './interfaces';

const DatePicker: React.FC<DatePickerProps> = ({
  question,
  errors,
  initialValues,
  onChange,
  type,
  viewOnly,
}) => {
  const disabled = !!viewOnly;
  const [date, setDate] = useState<[Date | null, Date | null] | undefined>(
    initialValues?.values,
  );
  const [maxDate, setMaxDate] = useState<Date | null>(null);

  const handleChangeDate = useCallback(
    (newDate: [Date | null, Date | null]) => {
      if (type === 'date_range') {
        // Período só conta como respondido com início e fim; só o início
        // deixava enviar a exportação sem data de fim
        onChange(newDate?.[0] && newDate?.[1] ? newDate : []);
        if (question.intervalDays) {
          const dateLimit = newDate?.[0] ? new Date(newDate?.[0]) : null;
          dateLimit?.setDate(
            dateLimit.getDate() + (question.intervalDays?.max || 30),
          );
          setMaxDate(dateLimit);
        }
      } else if (newDate[0]) {
        onChange(parseDateToDay(newDate[0]));
      }
      setDate(newDate);
    },
    [onChange, type, question.intervalDays],
  );

  return (
    <FormControl isInvalid={!!errors?.errors}>
      <QuestionTitle>{question.name}</QuestionTitle>
      {type === 'date_range' && question.intervalDays && question.intervalDays?.description && (
        <Text fontStyle="italic" color="gray.500">
          {question.intervalDays?.description}
        </Text>
      )}
      <WCDatePicker
        onChange={handleChangeDate}
        selected={date?.[0]}
        startDate={date?.[0]}
        endDate={date?.[1]}
        disabled={disabled}
        selectsRange={type === 'date_range'}
        maxDate={maxDate}
      />
      <FormHelperText>{question.tipText}</FormHelperText>
      <FormErrorMessage>{errors && errors.errors}</FormErrorMessage>
    </FormControl>
  );
};

export default DatePicker;
